import i18n, { t } from '@/languages';
/* eslint-disable @typescript-eslint/ban-types */
// 多端同步
export enum syncTypeEnum {
  sessionRead = 1,
  // 会话已读
  toggleTop = 2,
  // 会话置顶切换
  insert = 3,
  // 新增会话
  remove = 4,
  // 移除会话
  updateGroupName = 5,
  // 更新群名称
  updateAvatar = 6,
  // 更新群头像
  updateUserInfo = 7,
  // 更新用户信息 todo 未使用
  updateOrgName = 8,
  // 更新组织名字
  updateApprovalName = 9,
  // 更新审批名字
  disturb = 10,
  // 更新免打扰状态
  msgWithdraw = 11,
  // 消息撤回 todo 未使用 使用6003代替 后面优化
  msgRead = 12,
  // 消息已读
  logout = 13,
  // 退出登录 todo 未使用
  voiceListened = 14,
  // 语音已收听 todo 未使用 使用6003代替 后面优化
  groupNote = 15,
} // 群备注名

// 6003 的三端同步
export enum syncMsgTypeEnum {
  // 撤回
  recall = 10,
  // 语音已读
  listen = 11,
}
export enum editorDomTypeEnum {
  at = '0',
  img = '1',
  emoji = '2',
}
export enum NoticeEnum {
  none = '0',
  self = '1',
  all = '2',
}

// 会话类型
export enum SessionTypeEnum {
  single = 1,
  group = 2,
}

// 会话发送类型 回车发送 1 按钮点击 2
export enum SessionSendEnum {
  enter = 1,
  button = 2,
}

// 群会话类型，
export enum GroupTypeEnum {
  general = 2,
  project = 3,
}
export enum downloadTypeEnum {
  single = 1,
  pack = 2,
  folder = 3,
  batch = 4,
  // 勾选下载
  singleDiscuss = 5,
}
export enum positionTypeEnum {
  // single = 1,
  // pack = 2,
  // 消息中的定位 / 讨论文件合集第一级（原逻辑discussId）
  out = 2,
  // 讨论文件合集弹窗 单行的定位（280改造后，新的）
  innerRow = 1,
  // 讨论文件合集弹框 双击进入后 顶部定位（280改造后，新的）
  innerTop = 3,
  // 讨论文件合集第一级顶部定位（原逻辑discussId）
  outTop = 4,
}
// 另存为 入口
export enum saveAsTypeEnum {
  // 引导_多选
  guideMultiple = 1,
  // 聊天记录中（单文件）
  record = 2,
  // todo 消息_右键单文件/图片
  chatItemRight = 3,
  // 讨论文件合集 第一层 顶部
  // todo 消息_右键讨论文件合集
  out = 4,
  // 讨论文件合集 单行
  innerRow = 5,
  // 文件工具箱
  filTool = 6,
}
export enum openTypeEnum {
  file = 0,
  folder = 1,
}
export enum disturbTypeEnum {
  disturb = 0,
}
export enum MsgStatusEnum {
  default = 0,
  pending = 1,
  success = 2,
  fail = 3,
}
export const SaveAsActionType = {
  multiSelect: Symbol(i18n.t('1033')),
  firstNodeAllSelect: Symbol(i18n.t('1034')),
  allSelect: Symbol(i18n.t('1035'))
};
export enum MsgTypeEnum {
  toBottom = -7,
  // 回到底部(不是消息类型,为了消息的IntersectionObserver监听同步)
  groupAutoReply = -6,
  // 群聊自动回复
  singleAutoReply = -5,
  // 单聊自动回复
  period = -4,
  // 时间段(前端)
  read = -3,
  // 已读使用(前端)(不是消息类型,为了消息的IntersectionObserver监听同步)
  underLink = -2,
  // 只有app用
  null = -1,
  // 不支持类型(前端 + app)
  text = 0,
  pic = 1,
  file = 2,
  link = 3,
  systemTip = 4,
  at = 5,
  video = 6,
  reply = 7,
  systemMsg = 8,
  discuss = 9,
  withdraw = 10,
  notice = 11,
  // 抄送任务
  share = 12,
  // 分享任务
  audio = 13,
  chat = 14,
  // 聊天记录
  announcement = 15,
  // 公告
  diaryComment = 16,
  // 日志评论
  voice = 17,
  // 语音
  diary = 27,
  // SWHSWH 申请消息code
  application = 28,
  // SWHSWH 授权消息code
  authorization = 29,
} // 日志
// 26app已经占，请勿使用

// 任务
export enum TaskDeNoiseEnum {
  atAll = 0,
  // 在任务中@所有人
  add = 1001,
  // 创建
  addExecutor = 1002,
  // 添加执行人
  addCopy = 1003,
  // 添加抄送人
  editInfo = 2001,
  // 修改信息
  deleteExecutor = 3001,
  // 删除执行人
  deleteCopy = 3002,
  // 删除抄送人
  overdue = 4001,
  // 逾期
  atYou = 5001,
  // 在任务中@了你
  complete = 6001,
  // 完成
  close = 6002,
  // 关闭
  delete = 6003,
  // 删除
  cancelComplete = 6004,
  // 取消完成
  open = 6005,
} // 打开任务

export interface DraftItem {
  text: string;
}
export interface SessionItem {
  id: string;
  sessionId: string;
  type: SessionTypeEnum;
  image: string;
  name: string;
  top: boolean;
  notice: NoticeEnum;
  from: string;
  to: string;
  unreadNum: number;
  lastModifyTime: number;
  lastMessageText: string;
  updateTime: number;
  disturb: disturbTypeEnum;
  delFlag: boolean;
  show: boolean;
  customData?: any;
  draft?: DraftItem;
  sendStatus?: MsgStatusEnum;
  isReadLastMessage?: number;
}
export interface SessionListRes {
  chatSessions: Array<SessionItem>;
  unreadNum: number;
}
export interface CommonFileMsg {
  docName: string;
  docType: string;
  docSize: number;
  docPath: string;
  hashCode: string;
  from: string;
  to: string;
}
export interface TextMsg<Reply = {}> {
  type: MsgTypeEnum.text;
  text: string;
  reply: { [P in keyof Reply]?: Reply[P] };
}
export type PicMsg<Reply = {}> = CommonFileMsg & {
  type: MsgTypeEnum.pic;
  text: string;
  url: string;
  reply?: { [P in keyof Reply]?: Reply[P] };
};
export type FileMsg<Reply = {}> = CommonFileMsg & {
  type: MsgTypeEnum.file;
  text: string;
  url: '';
  reply: { [P in keyof Reply]?: Reply[P] };
};
// SWHSWH 授权消息
export type ApplicationMsg<Reply = {}> = CommonFileMsg & {
  type: MsgTypeEnum.application;
  text: string;
  url: '';
  reply: { [P in keyof Reply]?: Reply[P] };
};
export interface LinkMsg<Reply = {}> {
  type: MsgTypeEnum.link;
  text: string;
  url: string;
  reply: { [P in keyof Reply]?: Reply[P] };
}
export interface AtMsg<Reply = {}> {
  type: MsgTypeEnum.at;
  text: string;
  searchText: string;
  atList: Array<{
    name: string;
    crmId: string;
  }>;
  reply: { [P in keyof Reply]?: Reply[P] };
}
export type VideoMsg<Reply = {}> = CommonFileMsg & {
  type: MsgTypeEnum.video;
  text: string;
  reply: { [P in keyof Reply]?: Reply[P] };
};
export interface SystemTipMsg<Payload = {}> {
  type: MsgTypeEnum.systemTip;
  text: string;
  payload: { [P in keyof Payload]?: Payload[P] };
}
export interface AnnouncementMsg<Reply = {}> {
  type: MsgTypeEnum.announcement;
  text: string;
  height: number;
  width: number;
  reply: { [P in keyof Reply]?: Reply[P] };
}
export interface DiaryMsg<Reply = {}> {
  type: MsgTypeEnum.diaryComment;
  text: string;
  reply: { [P in keyof Reply]?: Reply[P] };
}
export interface VoiceMsg<Reply = {}> {
  type: MsgTypeEnum.voice;
  text: string;
  reply: { [P in keyof Reply]?: Reply[P] };
}

// eslint-disable-next-line max-len
export type GenericMsg<Reply = {}> = TextMsg<Reply> | PicMsg<Reply> | FileMsg<Reply> | LinkMsg<Reply> | AtMsg<Reply> | VideoMsg<Reply> | SystemTipMsg<Reply> | AnnouncementMsg<Reply> | DiaryMsg<Reply> | VoiceMsg<Reply>;
export interface BaseChatMsg {
  ext: string;
  from: string;
  to: string;
  seqId: string;
  sessionId: string;
  text: string;
  timestamp: number;
  status: MsgStatusEnum;
  sessionType: SessionTypeEnum;
  messageType: MsgTypeEnum;
  fromName: string;
  sessionName: string;
  searchText?: '';
}
export interface TimMsg {
  to: string;
  from: string;
  sessionId: string;
  sessionType: SessionTypeEnum;
  conversationType: any;
  payload: {
    data: string;
  };
}
export interface syncMsg {
  payLoad: any;
  receiver: Array<string>;
  timestamp: number;
  type: syncTypeEnum;
}
export enum insertTypeEnum {
  text = 'text',
  domNode = 'domNode',
}
export enum systemSessionEnum {
  text = 0,
  people = 1,
  project = 2,
  org = 3,
  applet = 4,
}

// 三段同步的 IM，撤回，收听语音
export enum updateMsgInfoImEnum {
  // 撤回
  withdraw = 11,
  // 语音收听
  voiceListen = 14,
}

// 展示主体消息
export enum messageBody {
  addTask = 1001,
  addTaskExecutors = 1002,
  addTaskCopyer = 1003,
  editorInfo = 2001,
  overdue = 4001,
  success = 6001,
  close = 6002,
  cancel = 6004,
  assignOpen = 6005,
}

// 循环ext中的内容，不需要接口获取
export enum consult {
  consult = 2002,
  // 参考文件、工具
  relation = 2003,
} // 关联文件

// 只有任务名称，不展示主体消息
export enum notBody {
  cancelExecutors = 3001,
  cancelCopyer = 3002,
  deleteTask = 6003,
}

// @提醒
export enum selectRemind {
  remind = 5001,
}

// 消息类型
export enum msgStatus {
  cancelRelevance,
  // 取消关联
  setRelevance,
  // 设为关联
  setPre,
  // 设为前置
  cancelPre,
} // 取消前置

// 分享消息状态
export enum shareTaskStatus {
  delOrClose = 1,
  status = 4,
}

// 消息转发类型
export enum relayTypeEnum {
  relay = -1,
  // 前端区分右键转发
  succession = 0,
  merge = 1,
}

// 消息拼接类型
export enum msgJoinTypeEnum {
  up = 1,
  down = 2,
  position = 3,
  success = 4,
  loading = 5,
  fail = 6,
}

// 客服在线枚举
export enum onlineServiceStateEnum {
  online = 0,
  busy = 1,
  offline = 2,
}

// 用戶身份類型
export enum UserIdentityEnum {
  service = 4,
} // 客服

export const AutoReplyMsgBadge = 'autoReply$$';
export const onlineStateIconEnum: {
  [key: string]: any;
} = {
  [onlineServiceStateEnum.online]: 'a-1xzaixian',
  [onlineServiceStateEnum.busy]: 'a-2xmanglu',
  [onlineServiceStateEnum.offline]: 'likai1'
};

// 加急类型
export enum urgentType {
  mail = 0,
  mailAndSMS = 1,
}

// 定位类型
export enum msgLocationType {
  msg = 0,
  // 定位消息
  spaceNotFullToChat = 1,
} // 组织空间不够定位到组织创建者会话发送假消息

// 会话删除后处理方式
export enum removeSessionTypeEnum {
  active = 1,
  // 主动删除
  passive = 2,
} // 被动删除

export interface mentionItem {
  crmId: string;
  name: string;
}

// 链接卡片类型
export enum linkMsgEnum {
  normal = 0,
  // 正常类型
  shareDocs = 1,
  // 外链文件分享
  shareInviteDiscuss = 2,
  // 外链讨论组邀请
  shareInvitePro = 3,
  // 外链项目邀请
  shareInviteOrg = 4,
} // 外链组织邀请